import { render, staticRenderFns } from "./RegistroFallecimiento.vue?vue&type=template&id=7de5fdb4&scoped=true"
import script from "./RegistroFallecimiento.vue?vue&type=script&lang=ts"
export * from "./RegistroFallecimiento.vue?vue&type=script&lang=ts"
import style0 from "./RegistroFallecimiento.vue?vue&type=style&index=0&id=7de5fdb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de5fdb4",
  null
  
)

export default component.exports